﻿import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import QRCode from 'react-qr-code';

type QrAttendee = { badgeNo: string; firstName: string; lastName: string };

export default function QrList() {
  const { id: eventId } = useParams();
  const [attendees, setAttendees] = useState<QrAttendee[]>([]);
  const [notAllowed, setNotAllowed] = useState(false);

  const fetchAttendees = useCallback(async () => {
    try {
      // Admin-only data: it comes from the admin site on this same host, with the admin login cookie.
      // Logged out, the admin answers with a redirect to its login page, so don't follow it.
      const response = await fetch(`/Home/QrListData?eventId=${encodeURIComponent(eventId ?? '')}`, {
        credentials: 'same-origin',
        redirect: 'manual',
      });
      if (!response.ok) {
        setNotAllowed(true);
        return;
      }
      setAttendees(await response.json());
    } catch (error) {
      console.error(error);
      setNotAllowed(true);
    }
  }, [eventId]);

  useEffect(() => {
    fetchAttendees();
  }, [fetchAttendees]);

  if (notAllowed) {
    return (
      <div className="flex items-center justify-center w-screen h-screen">
        <p className="text-xl">Log in to the Jirango admin and open this list from the event menu.</p>
      </div>
    );
  }

  return (
    <div className="snap-y snap-mandatory flex items-center justify-center w-screen h-screen overflow-auto">
      <div className='h-screen'>
        {attendees?.map(({ badgeNo, firstName, lastName }) => (
          <div className="snap-start h-full w-full" key={badgeNo}>
            <div className="flex items-center gap-5 mx-auto w-full h-full">
              <QRCode key={badgeNo} value={badgeNo} size={200} />
              <h3 className="text-2xl">
                {firstName} {lastName}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
